// extracted by mini-css-extract-plugin
export default {"tableV2__cellWrapper":"TableRow_tableV2__cellWrapper__z-2RP","tableV2__row":"TableRow_tableV2__row__hO6+E","tableV2__rowClickable":"TableRow_tableV2__rowClickable__YWUGd"};